import React from 'react';
import { Text } from '../../../CommonComponents/OPL/Text/Text';

export const DataReconciliationTableHeader = () => {
  return (
    <thead>
      <tr>
        <th>
          <Text variant="smallCaps" textAlign="left">
            Name
          </Text>
        </th>
        <th>
          <Text variant="smallCaps" textAlign="left">
            Last Update
          </Text>
        </th>
        <th>
          <Text variant="smallCaps" textAlign="left">
            Status
          </Text>
        </th>
        <th aria-label="Action header" />
      </tr>
    </thead>
  );
};
